import {
  faCircleExclamation,
  faCirclePlus,
  faFileArrowUp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Box, Grid, SelectChangeEvent } from "@mui/material";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ImageUploaderModal from "common/ImageUploaderModal";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getAllSubPagesList,
  SettingGroupdropdown,
  SettingsChildEdit,
  SettingsValidationDropdown,
  updateSettingsvalue,
} from "services/apiService";
import GoogleFontsDropdown from "./GoogleFontsDropdown";
import footer_1 from "../../assect/footer/footer_1.png";
import footer_2 from "../../assect/footer/footer_2.png";
import header_1 from "../../assect/header/header_1.png";
import header_2 from "../../assect/header/header_2.png";
import header_3 from "../../assect/header/header_3.png";
import header_4 from "../../assect/header/header_4.png";
import header_5 from "../../assect/header/header_5.png";
import ReusableEditor from "common/ReusableCKEditor";
import config from "config";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  border: "2px solid white",
  boxShadow: 24,
  p: 4,
};

interface SettingsSingleEditProp {
  settingsList: any;
  open: boolean;
  handleClose: () => void;
  id: number | null;
  onActionComplete: () => void;
}

interface ValidationType {
  type: string;
  placeholder: string;
  pattern: RegExp;
}

const keyOptionsMap: Record<
  string,
  { value: string; label: string; img_url: string }[]
> = {
  header: [
    {
      value: "1",
      label: "Header_1",
      img_url: header_1,
    },
    { value: "2", label: "Header_2", img_url: header_2 },
    { value: "3", label: "Header_3", img_url: header_3 },
    { value: "4", label: "Header_4", img_url: header_4 },
    { value: "5", label: "Header_5", img_url: header_5 },
  ],
  footer: [
    { value: "1", label: "Footer_1", img_url: footer_1 },
    { value: "2", label: "Footer_2", img_url: footer_2 },
  ],
};

const validationTypes: Record<string, ValidationType> = {
  TEXT_INPUT: { type: "text", placeholder: "Enter text", pattern: /.*/ },
  NUMBER_INPUT: {
    type: "text",
    placeholder: "Enter number",
    pattern: /^[\d\W]*$/,
  },
  TEXT_AREA: {
    type: "textarea",
    placeholder: "Enter description",
    pattern: /.*/,
  },
  EMAIL: {
    type: "email",
    placeholder: "Enter email",
    pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  },
  GST_NUMBER: {
    type: "text",
    placeholder: "Enter GST number",
    pattern: /^[0-9A-Z]{15}$/,
  },
  PAN_NUMBER: {
    type: "text",
    placeholder: "Enter PAN number",
    pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  },
  IMAGE_INPUT: {
    type: "file",
    placeholder: "Select an image",
    pattern: /.*/,
  },
};

interface ValidationOption {
  id: number;
  name: keyof typeof validationTypes;
}

interface GroupOption {
  id: number;
  name: string;
}

const SettingsSingleEdit: React.FC<SettingsSingleEditProp> = ({
  open,
  handleClose,
  id,
  settingsList,
  onActionComplete,
}) => {
  const [formValues, setFormValues] = useState({
    key_name: "",
    key_value: "",
    group_id: "",
    display_name: "",
    validation_id: "",
    is_active: 1,
  });

  const [selectedKeyvalue, setSelectedKeyvalue] = useState("");

  const isHeader = formValues.key_name.toLowerCase() !== "header";
  const isFooter = formValues.key_name.toLowerCase() !== "footer";

  const lowerKeyName = formValues?.key_name?.toLowerCase();
  const dynamicOptions = keyOptionsMap[lowerKeyName] || [];
  const showDynamicSelect = dynamicOptions?.length > 0;

  const AppUrl = config?.REACT_APP_IMAGE_URL;
  const [groups, setGroups] = useState<GroupOption[]>([]);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [validationDropdown, setValidationDropdown] = useState<
    ValidationOption[]
  >([]);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [selectedValidation, setSelectedValidation] =
    useState<ValidationOption | null>(null);
  const [subPagesLinks, setSubPagesLinks] = useState([]);

  useEffect(() => {
    fetchValidationDropdown();
    fetchGroups();
    fetchPrivacyPolicyData();
  }, []);

  const fetchGroups = async () => {
    try {
      const response = await SettingGroupdropdown();
      setGroups(response.data);
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const fetchValidationDropdown = async () => {
    try {
      const response = await SettingsValidationDropdown();
      if (response.status_code === 200) {
        setValidationDropdown(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchPrivacyPolicyData = async () => {
    try {
      const response = await getAllSubPagesList();
      if (response.status_code === 200) {
        setSubPagesLinks(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    if (name === "validation_id") {
      const selectedItem = validationDropdown.find(
        (item) => item.id === Number(value)
      );
      console.log("Selected validation:", selectedItem);
      setSelectedValidation(selectedItem || null);
      setFormValues((prev) => ({
        ...prev,
        validation_id: value,
      }));
    } else {
      setFormValues((prev) => {
        const updatedValues = { ...prev, [name]: value };
        console.log("Updated form values:", updatedValues);
        return updatedValues;
      });

      setErrors((prev) => {
        const updatedErrors = {
          ...prev,
          [name]: value ? "" : "This field is required",
        };
        console.log("Updated errors:", updatedErrors);
        return updatedErrors;
      });
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchSettingsSingleEdit(id);
  }, [id]);

  const fetchSettingsSingleEdit = async (id: number) => {
    try {
      const response = await SettingsChildEdit(id);
      if (response.status_code === 200) {
        const matchedValidation =
          validationDropdown.find(
            (item) => item.id === response.data.validation_key
          ) || null;
        setFormValues({
          key_name: response.data.key_name,
          key_value: response.data.key_value,
          group_id: response.data.group_id,
          display_name: response.data.display_name,
          is_active: response.data.is_active,
          validation_id: response.data.validation_key,
        });
        setSelectedValidation(matchedValidation);
      } else {
        console.warn("Data is empty or not an array");
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));

    if (selectedValidation) {
      const validationRule = validationTypes[selectedValidation.name]?.pattern;
      setErrors((prev) => ({
        ...prev,
        [name]: validationRule?.test(value) ? "" : "Invalid format",
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const keyValue =
        lowerKeyName === "header" || lowerKeyName === "footer"
          ? selectedKeyvalue
          : String(formValues.key_value);
      const payload = {
        id: id,
        key_name: formValues.key_name,
        key_value: keyValue,
        is_active: formValues.is_active,
        group_id: formValues.group_id,
        display_name: formValues.display_name,
        validation_key: Number(formValues.validation_id),
        is_viewed: 1,
      };

      console.log(payload, "pay");
      const response = await updateSettingsvalue(payload);
      if (response.status_code === 200) {
        toast.success("Settings Updated Successfully");
        handleClose();
        onActionComplete();
      }
    } catch (error) {
      toast.error("Settings Update failed");
    }
  };

  const handleImageSelected = (image) => {
    const finalImage = image[0];
    setFormValues((prev) => ({
      ...prev,
      key_value: finalImage,
    }));
    setModalOpen(false);
  };

  const handleChange = (event, editor) => {
    const data = editor.getData();
    setFormValues((prevState) => ({
      ...prevState,
      key_value: data,
    }));
  };

  const handleDeleteImage = () => {
    setFormValues((prevState) => ({
      ...prevState,
      key_value: "",
    }));
  };

  const handleFontSelection = (fontData: {
    fontFamily: string;
    fontCDN: string;
  }) => {
    setFormValues((prev) => ({
      ...prev,
      key_value: JSON.stringify(fontData),
    }));
  };

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  useEffect(() => {
    const lowerKey = formValues?.key_name?.toLowerCase();
    if (
      (lowerKey === "header" || lowerKey === "footer") &&
      formValues.key_value
    ) {
      setSelectedKeyvalue(formValues.key_value);
    }
  }, [formValues]);

      const handleTextFieldChange = (
        e: React.ChangeEvent<HTMLInputElement>
      ) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({
          ...prev,
          [name]: value ? value : "",
        }));
      };
  return (
    <>
      <Modal open={open} onClose={undefined}>
        <Box sx={style}>
          <Typography
            variant="h6"
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              backgroundColor: "#007bff",
              padding: "5px",
              color: "white",
            }}
          >
            Edit Setting
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box p={3}>
              <Grid container spacing={2} alignItems="center" mb={2}>
                <Grid item xs={4}>
                  <Typography variant="subtitle1">
                    Settings Field Type{" "}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <FormControl
                    fullWidth
                    variant="filled"
                    error={!!errors.validation_id}
                  >
                    <InputLabel>Select type</InputLabel>
                    <Select
                      name="validation_id"
                      value={formValues.validation_id}
                      onChange={handleSelectChange}
                    >
                      {validationDropdown?.map(({ id, name }) => (
                        <MenuItem key={id} value={id}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.validation_id}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              {selectedValidation && (
                <Grid container spacing={2} alignItems="center" mb={2}>
                  <Grid item xs={4}>
                    <Typography variant="subtitle1">Select Group </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <FormControl
                      fullWidth
                      variant="filled"
                      error={!!errors.group_id}
                    >
                      <InputLabel>Select Group</InputLabel>
                      <Select
                        name="group_id"
                        value={formValues.group_id}
                        onChange={handleSelectChange}
                      >
                        {groups?.map(({ id, name }) => (
                          <MenuItem key={id} value={id}>
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{errors.group_id}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="subtitle1">Key Name</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      variant="filled"
                      name="key_name"
                      value={formValues.key_name}
                      onChange={handleInputChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="subtitle1">Display Name</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      variant="filled"
                      name="display_name"
                      value={formValues.display_name}
                      onChange={handleInputChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              )}

              {showDynamicSelect && (
                <>
                  <p>Preview: </p>
                  {isFooter ? (
                    <ImageSelector
                      keyType="header"
                      selectedKeyvalue={selectedKeyvalue}
                      keyOptionsMap={keyOptionsMap}
                      setSelectedKeyvalue={setSelectedKeyvalue}
                    />
                  ) : (
                    <ImageSelector
                      keyType="footer"
                      selectedKeyvalue={selectedKeyvalue}
                      keyOptionsMap={keyOptionsMap}
                      setSelectedKeyvalue={setSelectedKeyvalue}
                    />
                  )}
                </>
              )}

              {selectedValidation && isHeader && isFooter && (
                <>
                  {selectedValidation.name === "CK_EDITOR" ? (
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">Key Value</Typography>
                      </Grid>

                      <Grid item xs={8}>
                        <ReusableEditor
                          value={formValues.key_value}
                          onChange={(value) =>
                            setFormValues((prevState) => ({
                              ...prevState,
                              key_value: value,
                            }))
                          }
                        />
                      </Grid>
                    </Grid>
                  ) : selectedValidation.name === "IMAGE" ? (
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">Key Value</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <div
                          style={{
                            width: "100%",
                            padding: "20px",
                            borderRadius: "10px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "#fff",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "center",
                              marginBottom: "20px",
                              border: "1px dashed #ccc",
                              padding: "20px",
                              display: "flex",
                              justifyContent: "center",
                              borderRadius: "10px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            {formValues.key_value ? (
                              <>
                                <img
                                  src={`${AppUrl}${formValues.key_value}`}
                                  alt="Selected"
                                  style={{
                                    width: "300px",
                                    transition: "transform 0.2s",
                                    cursor: "pointer",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1.05)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor: "rgba(255, 0, 0, 0.7)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "30px",
                                    height: "30px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
                                    transition: "background-color 0.2s",
                                  }}
                                  onClick={handleDeleteImage}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </>
                            ) : (
                              <p style={{ color: "orange" }}>
                                <FontAwesomeIcon icon={faCircleExclamation} />
                                &nbsp; &nbsp; No image selected. Please upload
                                an image.
                              </p>
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              onClick={handleOpenModal}
                              variant="contained"
                              color="primary"
                            >
                              <FontAwesomeIcon icon={faFileArrowUp} /> &nbsp;
                              &nbsp; Upload Image
                            </Button>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  ) : selectedValidation.name === "PRIVACY_POLICY" ? (
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">Key Value</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <TextField
                          select
                          variant="filled"
                          name="key_value"
                          value={formValues.key_value || ""}
                          onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: "key_value",
                                value: e.target.value,
                              },
                            } as React.ChangeEvent<HTMLInputElement>)
                          }
                          fullWidth
                        >
                          {subPagesLinks?.map((page) => (
                            <MenuItem key={page.page_id} value={page.page_id}>
                              {page.page_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  ) : selectedValidation.name === "FONT_FAMILY" ? (
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          Select Font Family
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <GoogleFontsDropdown
                          onSelectFont={handleFontSelection}
                          selectedFontFamily={
                            JSON.parse(formValues.key_value || "{}").fontFamily
                          }
                        />
                      </Grid>
                    </Grid>
                  ) : selectedValidation.name === "COLOR_PICKER" ? (
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">
                          Select Color
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Box display="flex" alignItems="center" gap={2}>
                          <TextField
                            variant="filled"
                            id="background_color"
                            name="key_value"
                            value={formValues.key_value}
                            onChange={handleTextFieldChange}
                            placeholder="#000000"
                            className="common_input"
                            sx={{ width: "25%" }}
                          />
                          <input
                            type="color"
                            id="background_color"
                            name="key_value"
                            value={formValues.key_value}
                            onChange={handleTextFieldChange}
                            style={{
                              width: "50px",
                              height: "50px",
                              border: "none",
                              cursor: "pointer",
                              marginLeft: "10px",
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item xs={4}>
                        <Typography variant="subtitle1">Key Value</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <TextField
                          variant="filled"
                          name="key_value"
                          type={
                            validationTypes[selectedValidation?.name]?.type ||
                            "text"
                          }
                          placeholder={
                            validationTypes[selectedValidation?.name]
                              ?.placeholder || "Enter value"
                          }
                          value={formValues.key_value}
                          onChange={handleInputChange}
                          fullWidth
                          error={!!errors.key_value}
                          helperText={errors.key_value}
                        />
                      </Grid>
                    </Grid>
                  )}
                </>
              )}

              <Box pb={2}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      fullWidth
                      disabled={!selectedValidation}
                    >
                      <FontAwesomeIcon
                        style={{ marginRight: "10px" }}
                        icon={faCirclePlus}
                      />
                      Create Setting
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => handleClose()}
                      fullWidth
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </form>
        </Box>
      </Modal>
      <ImageUploaderModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onImageSelect={handleImageSelected}
        allowMultiple={false}
      />
    </>
  );
};

export default SettingsSingleEdit;

type ImageSelectorProps = {
  keyType: "header" | "footer";
  selectedKeyvalue: string;
  keyOptionsMap: any;
  setSelectedKeyvalue: (value: string) => void;
};

const ImageSelector = ({
  keyType,
  selectedKeyvalue,
  setSelectedKeyvalue,
}: ImageSelectorProps) => {
  const options = keyOptionsMap[keyType];
  const [modalOpen, setModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const selectedOption = options.find(
    (opt: any) => opt.value === selectedKeyvalue
  );
  return (
    <>
      {selectedOption?.img_url && (
        <div
          className="mb-4 p-3  p-3"
          style={{
            border: "1px solid #000",
            position: "relative",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img
            src={selectedOption?.img_url}
            alt={selectedOption?.img_url}
            style={{
              width: "100%",
              minHeight: "10px",
              objectFit: "contain",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "0",
              bottom: "0",
              right: "0",
              left: "0",
              background: "rgba(0,0,0,0.7)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.3s ease",
            }}
            onClick={() => setModalOpen(true)}
          >
            Tap to preview
          </div>
        </div>
      )}

      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            width: "80%",
            minHeight: "10px",
            outline: "none",
          }}
        >
          <img
            src={selectedOption?.img_url}
            alt={selectedOption?.label}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Modal>

      <Grid container spacing={2} alignItems="center" mb={2}>
        <Grid item xs={4}>
          <Typography variant="subtitle1">{keyType} value</Typography>
        </Grid>
        <Grid item xs={8}>
          <FormControl fullWidth>
            <InputLabel id="dynamic-select-label">Select the value</InputLabel>
            <Select
              labelId="dynamic-select-label"
              id="dynamic-select"
              value={selectedKeyvalue}
              label="Choose an option"
              onChange={(e) => setSelectedKeyvalue(e.target.value)}
            >
              {options?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
